import { useQuery } from 'react-query';
import { listAlertInstances } from '../services/alertInstanceService';

export const useAlertInstances = (queryParams = {}) => {
  return useQuery(
    ['alert-instances', queryParams], 
    () => listAlertInstances(queryParams), 
    {
      staleTime: 2 * 60 * 1000, // 2 minutes
      cacheTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      // Refetch every 30 seconds for real-time updates
      refetchInterval: 30000,
    }
  );
};